function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M281.915 87.7765C221.926 75.889 163.137 62.3128 114.342 34.1515C38.4964 -9.62185 -37.8968 129.349 35.4602 108.995C239.126 52.4853 241.597 219.361 316.662 191.834C391.717 164.311 411.641 113.483 281.915 87.7765Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M258 23.0776L217.774 44.3315L185.577 51.3903L153.072 44.3315L113 23L126.821 87.1497L113.695 123.142L159.712 151.842L185.268 179.767V180L185.423 179.845L185.577 180V179.767L211.134 151.842L257.305 123.142L244.179 87.2273L258 23.0776Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 301.5,
  cy: 58.5,
  r: 9.5,
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 258,
  cy: 102,
  r: 34,
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 84.5,
  r: 17.5,
  fill: "url(#paint3_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 272.617,
  y1: 242.673,
  x2: 95.7522,
  y2: 13.41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#315EFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#315EFB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 312.915,
  y1: 75.5847,
  x2: 292,
  y2: 46.2292,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#315EFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#315EFB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 298.855,
  y1: 163.145,
  x2: 224,
  y2: 58.0833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#28BC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28BC00",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 113.45,
  y1: 95.5969,
  x2: 67.0278,
  y2: 92.7225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEEFF",
  stopOpacity: 0
})));

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 221,
    viewBox: "0 0 381 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.6a425345.svg";
export { ForwardRef as ReactComponent };